module.exports = "<div class=\"container-fluid\" [innerHTML]=\"videoItem.longDescription\">\n   \n</div>"